module.exports = __webpack_public_path__ + "static/media/Homestyle-Chicken-BLT_780x390.3159efff.jpg";